export default "__VITE_ASSET__Cc2b86IH__"